module.exports = __webpack_public_path__ + "img/buetti-news.308e3010.jpg";